export default __webpack_public_path__ + "static/media/interface.22f9daef.jpg";